<template>
  <b-container v-if="auth == 'loggedin' || token != null || token != undefined">
    <b-card
      class="text-center mt-5"
      header="Jelszó szerkesztése"
      border-variant="danger"
      header-bg-variant="danger"
      header-text-variant="white"
    >
      <b-card-body>
        <div class="col-sm-12">
          <div class="row-fluid">
            <!-- // FORM -->
            <b-form @submit="addElement">

              <div style="text-align:center">
                <div class="form-group">
                  <label for="old_password">Régi jelszó</label>
                  <b-form-input
                    ref="old_password"
                    type="password"
                    v-model="list.old_password"
                    class="form-control"
                    id="old_password"
                    required
                  />
                </div>

                <div id="app2" class="form-group">
                  <label for="email">Új jelszó</label>
                  <div class="input_container">
                    <input type="password" @input="p_len" v-model="password" placeholder="" >
                    <span v-bind:class="{ valid_password_length: valid_password_length , show_password_length: typed}" class="password_length">{{password_length}}</span>
                  </div>
                  <div class="lnu_container">
                    <p v-bind:class="{ lovercase_valid: contains_lovercase }">Kisbetű</p>
                    <p v-bind:class="{ number_valid: contains_number }">Szám</p>
                    <p v-bind:class="{ uppercase_valid: contains_uppercase }">Nagybetű</p>
                  </div>
                  <div class="valid_password_container" v-bind:class="{show_valid_password_container : valid_password }">
                    <svg width="100%" height="100%" viewBox="0 0 140 100">
                    <path class="tick" v-bind:class="{checked: valid_password }"
                          d="M10,50 l25,40 l95,-70" />
                  </svg>
                  </div>
                </div>

                <!-- // SAVE -->
                <b-button variant="primary"
                  type="submit"
                  class="float-left"
                  ><b-icon-cloud-upload></b-icon-cloud-upload>
                  Mentés
                </b-button>

                <!-- // CANCEL -->
                <b-button
                  variant="outline-danger"
                  class="float-right"
                  @click="
                    $router.push({
                      name: 'Profile'
                    })
                  "
                  ><b-icon-x-circle></b-icon-x-circle>
                  Mégsem
                </b-button>
              </div>

            </b-form>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </b-container>
</template>

<script>
import axios from 'axios'
import router from '../router'
import jwtDecode from 'jwt-decode'

export default {
  data: () => {
    const token = localStorage.usertoken
    const decoded = jwtDecode(token)
    return {
      password_length: 0,
      typed: false,
      contains_lovercase: false,
      contains_number: false,
      contains_uppercase: false,
      valid_password_length: false,
      valid_password: false,
      password: null,

      token: localStorage.usertoken,
      auth: '',
      userType: decoded.usertype,
      list: {}
    }
  },
  methods: {
    p_len: function () {
      this.password_length = this.password.length
      if (this.password_length > 7) {
        this.valid_password_length = true
      } else {
        this.valid_password_length = false
      }

      if (this.password_length > 0) {
        this.typed = true
      } else {
        this.typed = false
      }

      this.contains_lovercase = /[a-z]/.test(this.password)
      this.contains_number = /\d/.test(this.password)
      this.contains_uppercase = /[A-Z]/.test(this.password)

      // Check if the password is valid
      if (this.contains_lovercase === true && this.contains_number === true) {
        this.valid_password = false
        if (
          this.contains_uppercase === true &&
          this.valid_password_length === true
        ) { this.valid_password = true }
      } else {
        this.valid_password = false
      }
    },
    addElement: function () {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        if (
          this.contains_lovercase === true &&
          this.contains_number === true &&
          this.contains_uppercase === true &&
          this.typed === true &&
          this.valid_password_length === true &&
          this.valid_password === true
        ) {
          payload.token = this.token
          payload.userType = this.userType
          payload.old_password = this.list.old_password
          payload.new_password = this.password
          payload.id = this.list.id
          axios
            .post('http://' + process.env.ROOT_API + '/users/changepassword', { payload })
            .then(res => {
              if (res.data.result === 'NO') {
                alert('Régi jelszó nem helyes!')
                this.list.old_password = ''
                this.$refs.old_password.focus()
              } else {
                this.$router.push({ name: 'Profile' })
              }
            })
            .catch(err => {
              console.log(err)
            })
        }
      }
    }
  },
  mounted: function () {
    let payload = {}
    if (!this.token) {
      router.push({ name: 'Login' })
    } else {
      payload.token = this.token
      payload.userType = this.userType
      payload.email = this.$route.params.email
      if (this.$route.params.email) {
        axios
          .post('http://' + process.env.ROOT_API + '/users/edit', { payload })
          .then(res => {
            this.list = res.data
            this.list.id = res.data.id
          })
          .catch(err => {
            console.log(err)
          })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/UserNewPassword.vue